<template>
        <div style="padding:20px">
        <div>
            <a-table :loading="loading"  :scroll="{ y: tableHeight }"  :pagination="false" :dataSource="list" :columns="columns" >
                <template #bodyCell="{ column,text, record }">
                    <template v-if="column.key === 'yesterdayNum'">
                        <a-tag color="#2db7f5">{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'todayNum'">
                        <a-tag v-if="text==0" color="error">{{text}}</a-tag>
                        <a-tag v-else-if="text<record.YesterdayNum" color="warning">{{text}}</a-tag>
                        <a-tag v-else color="success">{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'tomorrowNum'">
                        <a-tag color="#108ee9">{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'yesterdayMoney'" >
                        <div style="cursor:pointer;font-weight:600">
                            ￥ {{text.toFixed(2)}}
                        </div>
                    </template>
                    <template v-else-if="column.key === 'todayMoney'" >
                        <div style="cursor:pointer;font-weight:600">
                            ￥ {{text.toFixed(2)}}
                        </div>
                    </template>
                    <template v-else-if="column.key === 'tomorrowMoney'" >
                        <div style="cursor:pointer;font-weight:600">
                            ￥ {{text.toFixed(2)}}
                        </div>
                    </template>
                    <template v-else-if="column.key === 'action'" >
                        <a-tooltip placement="bottom">
                            <template #title>
                            <span>一键登陆</span>
                            </template>
                            <a-button @click="login(record)" type="dashed" shape="circle">
                                <template #icon><ie-outlined /></template>
                            </a-button>
                        </a-tooltip>
                    </template>
                </template>
                
                <template #summary>
                    <a-table-summary fixed>
                    <a-table-summary-row>
                        <a-table-summary-cell :col-span="3">
                            <div style="text-align:center">
                                <b>统计</b>
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <a-tag color="#2db7f5">{{totals.totalYesterdayNum}}</a-tag>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <a-tag v-if="totals.totalTodayNum<totals.totalYesterdayNum" color="error">{{totals.totalTodayNum}}</a-tag>
                            <a-tag v-else color="success">{{totals.totalTodayNum}}</a-tag>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <a-tag color="#108ee9">{{totals.totalTomorrowNum}}</a-tag>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.totalYesterdayMoney.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.totalTodayMoney.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.totalTomorrowMoney.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                    </a-table-summary-row>
                    </a-table-summary>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
import {  ref,computed} from 'vue';
import { taskGetPlanStatisticsReq,memberLoginReq } from '@/request.js';
import {config} from '../config'

import {  IeOutlined} from '@ant-design/icons-vue';

 

export default {
    components: {
        IeOutlined
    },
    setup() {
        const loading=ref(false);
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260+52;
        const list=ref([]);
        loading.value=true;
        taskGetPlanStatisticsReq({},(res)=>{
            list.value=res.Result;
            loading.value=false;
        })
        const login=(record)=>{
            memberLoginReq({
                phone:record.Phone,
                password:record.LoginPwd,
            },(res)=>{
                window.open(config.merchantServer+"/#/?token="+res.Message);
            })
        }
        const totals = computed(() => {
            let totalTodayMoney = 0;
            let totalTodayNum = 0;
            let totalTomorrowMoney = 0;
            let totalTomorrowNum = 0;
            let totalYesterdayMoney = 0;
            let totalYesterdayNum = 0;
            list.value.forEach(({
                TodayMoney,
                TodayNum,
                TomorrowMoney,
                TomorrowNum,
                YesterdayMoney,
                YesterdayNum
            }) => {
                totalTodayMoney += TodayMoney;
                totalTodayNum += TodayNum;
                totalTomorrowMoney += TomorrowMoney;
                totalTomorrowNum += TomorrowNum;
                totalYesterdayMoney += YesterdayMoney;
                totalYesterdayNum += YesterdayNum;
            });
            return {
                totalTodayMoney,
                totalTodayNum,
                totalTomorrowMoney,
                totalTomorrowNum,
                totalYesterdayMoney,
                totalYesterdayNum,
            };
        });
        return{
            login,
            totals,
            tableHeight,
            loading,
            list,
            columns: [
                {
                    title: '代理名称',
                    dataIndex: 'AgentName',
                    key: 'agentName',
                },
                {
                    title: '商家名称',
                    dataIndex: 'MemberName',
                    key: 'memberName',
                },
                {
                    title: '店铺名称',
                    dataIndex: 'ShopName',
                    key: 'shopName',
                },
                {
                    title: '昨日单量',
                    dataIndex: 'YesterdayNum',
                    key: 'yesterdayNum',
                },
                {
                    title: '今日单量',
                    dataIndex: 'TodayNum',
                    key:'todayNum',
                },
                {
                    title: '明日单量',
                    dataIndex: 'TomorrowNum',
                    key: 'tomorrowNum',
                },
                {
                    title: '昨日货款',
                    dataIndex: 'YesterdayMoney',
                    key: 'yesterdayMoney',
                },
                {
                    title: '今日货款',
                    dataIndex: 'TodayMoney',
                    key:'todayMoney',
                },
                {
                    title: '明日货款',
                    dataIndex: 'TomorrowMoney',
                    key: 'tomorrowMoney',
                },
                {
                    title: '操作',
                    key: 'action',
                },
            ],
        }
    },
}
</script>
